import { Provider } from 'mobx-react'
import { configure } from 'mobx'
import promiseFinally from 'promise.prototype.finally'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { unregister } from './registerServiceWorker'
import ServiceBase from './services/ServiceBase'
import stores from './Stores'

// Configure MobX to isolate global state when multiple versions exist
configure({ isolateGlobalState: true })

promiseFinally.shim()
// Axios integration configuration for requests
ServiceBase.attachAuthInterceptor()

const root = (
  <Provider {...stores}>
    <App />
  </Provider>
)

const container = document.getElementById('root') as HTMLElement
createRoot(container).render(root)
unregister()
